import * as request from './utils/requester';

export const getAll = (page) => request.get(`/enroll?page=${page}`);

export const getById = (id) => request.get(`/enroll/${id}`);

export const create = (data) => request.post('/enroll', data);

export const edit = (data) => request.put(`/enroll/${data._id}`, data);

export const del = (data) => request.del(`/enroll/${data._id}`);


export const getOption = (option) => request.get(`/enroll?option=${option}`);